/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ComplexStatisticsCard({
  color,
  title,
  count,
  percentage,
  icon,
  cardTitle,
}) {
  return (
    <Card border={`3px solid ${color}`}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        pt={1}
        px={2}
        border={`3px solid ${color}`}
        height="5rem"
      >
        <MDBox
          variant="gradient"
          bgColor={color}
          color="white"
          coloredShadow="dark"
          style={{ color: "white" }}
          borderRadius={10}
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="auto"
          height="4rem"
          mt={0}
          mb={0.5}
          padding={2.5}

          // border={`2px solid ${color}`}
        >
          <Icon fontSize="medium" color="inherit">
            {icon}
          </Icon>
        </MDBox>
        {/* <MDBox pb={2} px={2}>
          <MDTypography variant="h6" textTransform="capitalize">
            {cardTitle}
          </MDTypography>
        </MDBox> */}
        <MDTypography
          variant="h6"
          textTransform="capitalize"
          style={{
            marginLeft: "15px",
            fontWeight: 500,
            float: "left",
            justifyContent: "left",
            marginRight: "auto",
          }}
        >
          {cardTitle}
          <MDTypography variant="h4">{count}</MDTypography>
        </MDTypography>

        {/* <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography
            variant="button"
            fontWeight="light"
            color="text"
          ></MDTypography>
          <MDTypography variant="h4"></MDTypography>
        </MDBox> */}
      </MDBox>
      {/* <Divider /> */}
      {/* <MDBox pb={2} px={2}>
        <MDTypography variant="h6" textTransform="capitalize">
          {cardTitle}
        </MDTypography>
      </MDBox>
      <MDBox pb={2} px={2}>
        <MDTypography
          component="p"
          variant="button"
          color="text"
          display="flex"
        >
          <MDTypography
            component="span"
            variant="button"
            fontWeight="bold"
            color={percentage.color}
          >
            {percentage.amount}
          </MDTypography>
          &nbsp;{percentage.label}
        </MDTypography>
      </MDBox> */}
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

export default ComplexStatisticsCard;
